import { FC, useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import * as Sentry from "@sentry/react";

import HomePage from "./pages/home";
import Login from "./pages/login";
import OrdersPage from "./pages/orders";
import OrderPage from "./pages/order";
import OrderReportPage from "./pages/order-report";
import { authService } from "./services/firebase";
import withAuthentication from "./hoc/withAuthentication";
import { useAuthMutations } from "./store/use-auth-mutations";
import { InvoicePage } from "./pages/invoice/invoice";
import { InvoicesPage } from "./pages/invoices/invoices";
import { MoneyMovementsPage } from "./pages/movements/money-movements";
import { VirtualMenuPage } from "./pages/virtual-menu/virtual-menu";
import { SettingsPage } from "./pages/settings/settings";
import { PrinterSettings } from "./pages/settings/printer/printer-settings";

const Home = withAuthentication(HomePage);
const Orders = withAuthentication(OrdersPage);
const Order = withAuthentication(OrderPage);
const OrderReport = withAuthentication(OrderReportPage);
const Invoice = withAuthentication(InvoicePage);
const Invoices = withAuthentication(InvoicesPage);
const Movements = withAuthentication(MoneyMovementsPage);
const VirtualMenu = withAuthentication(VirtualMenuPage);
const Settings = withAuthentication(SettingsPage);

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

const App: FC = () => {
	const { updateToken } = useAuthMutations();

	useEffect(() => {
		const id = window.setInterval(() => {
			authService.getNewToken();
		}, 3000000);
		const unsubscribe = authService.onNewToken(updateToken);

		return () => {
			unsubscribe();
			clearInterval(id);
		};
	}, [updateToken]);

	return (
		<SentryRoutes>
			<Route path="/" element={<Home />} />
			<Route path="/login" element={<Login />} />
			<Route path="/order/:id?" element={<Order />} />
			<Route path="/orders" element={<Orders />} />
			<Route path="/order-report" element={<OrderReport />} />
			<Route path="/invoice/:id?" element={<Invoice />} />
			<Route path="/invoices" element={<Invoices />} />
			<Route path="/movements" element={<Movements />} />
			<Route path="/virtual-menu" element={<VirtualMenu />} />
			<Route path="/settings" element={<Settings />}>
				<Route index element={<Navigate to="printer" replace />} />
				<Route path="printer" element={<PrinterSettings />} />
			</Route>
		</SentryRoutes>
	);
};

export default App;
